__turbopack_context__.v({
  "className": "inter_9b02b30a-module__tyeKSq__className",
});
